import {
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  Modal,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { IconDownload } from "../../utils/icons";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  open: boolean;
  onClose: () => void;
  downloadSource: string;
  fileName?: string;
  /**
   * Called instead of onClose when the user accepts the terms and starts
   * the download. Lets callers distinguish "downloaded" from "dismissed"
   * (e.g. the global download tracker keeps dismissed downloads around).
   */
  onProceed?: () => void;
}
export function DownloadVideoModal({
  open,
  onClose,
  downloadSource,
  fileName,
  onProceed,
}: Props) {
  const videoRef = useRef<HTMLAnchorElement>(null);
  const [isTermChecked, setIsTermChecked] = useState(false);
  const cancel = () => {
    setIsTermChecked(false);
    onClose();
  };

  return (
    <Modal
      open={open}
      className="flex items-center flex-col justify-center"
      onClose={() => {
        setIsTermChecked(false);
        onClose();
      }}
    >
      <div className="bg-surface py-6 rounded-xl w-[450px] max-sm:w-[calc(100vw-24px)]">
        <div className="px-6 flex items-center justify-between">
          <Typography variant="h5">Terms & Conditions</Typography>
          <CloseIcon onClick={cancel} />
        </div>
        <div className="py-4 p-6">
          <div className="font-CircularStdBlack text-text-1">
            <FormControlLabel
              control={
                <Checkbox
                  checked={isTermChecked}
                  onChange={(e) => setIsTermChecked(e.target.checked)}
                />
              }
              label="I agree to the licensing agreement with The Desire Company for this media."
            />
          </div>
        </div>
        <div className="border-t border-border-token pt-4 flex items-center justify-end px-6 gap-3">
          <Button className="!bg-surface-2 !py-3 !px-4" onClick={cancel}>
            <Typography className="text-text-1 normal-case">Cancel</Typography>
          </Button>
          <Button
            className="flex gap-2 transform-0 rounded-3 !py-3 !px-4"
            variant="contained"
            color="primary"
            disabled={!isTermChecked}
            onClick={() => {
              videoRef.current?.click();
              setIsTermChecked(false);
              (onProceed ?? onClose)();
            }}
          >
            <IconDownload width={24} height={24} stroke="#fff" />
            <Typography className="text-white normal-case">
              Proceed to download
            </Typography>
          </Button>
          <a href={downloadSource} download={fileName || true} ref={videoRef} />
        </div>
      </div>
    </Modal>
  );
}
